let cachedPattern: CanvasPattern | null = null;
let cachedCanvas: HTMLCanvasElement | null = null;

function ensurePatternCanvas(): HTMLCanvasElement {
  if (cachedCanvas) return cachedCanvas;
  const off = document.createElement('canvas');
  off.width = 256;
  off.height = 256;
  const oc = off.getContext('2d')!;
  const img = oc.createImageData(256, 256);
  const d = img.data;
  for (let i = 0; i < d.length; i += 4) {
    const v = Math.random();
    const alpha = v < 0.86 ? 0 : Math.floor(((v - 0.86) / 0.14) * 180);
    d[i] = 255;
    d[i + 1] = 255;
    d[i + 2] = 255;
    d[i + 3] = alpha;
  }
  oc.putImageData(img, 0, 0);
  cachedCanvas = off;
  return off;
}

export function getChalkPattern(ctx: CanvasRenderingContext2D): CanvasPattern {
  if (cachedPattern) return cachedPattern;
  const canvas = ensurePatternCanvas();
  cachedPattern = ctx.createPattern(canvas, 'repeat')!;
  return cachedPattern;
}
